import { LazyImage } from 'components'
import { parse } from 'marked'

import css from './ExpertBox.module.css'

export default function ExpertBox({ name, description, content, avatarUrl, avatarAlt }) {
    return (
        <div className={css.expertBox}>
            <div className={css.expertContainer}>
                <LazyImage src={avatarUrl} alt={avatarAlt} />
                <div>
                    <div className={css.name}>{name}</div>
                    <div
                        className={css.title}
                        dangerouslySetInnerHTML={{ __html: parse(description) }}
                    />
                </div>
            </div>
            <div className={css.content} dangerouslySetInnerHTML={{ __html: parse(content) }} />
        </div>
    )
}
